import { Button, Col, FormGroup, Input, Row } from 'reactstrap';
import React, { Component } from 'react';
import { callApi, formatDate } from '../../utils';

import CreateCareerModal from './CreateCareerModal';
import SearchForm from '../SearchForm';
import { connect } from 'react-redux';
import { openCreateCareerModal } from '../../actions/modalActions';
import { showError } from '../../actions/notificationActions';
import DataTable, { PageHeader } from '../DataTable';

class Careers extends Component {
  state = {
    careers: [],
    team: '',
    query: '',
    page: 1,
    limit: 30,
    loading: false,
    teams: [
      'engineering',
      'customer_support',
      'marketing',
      'hr',
      'sales',
      'other',
    ],
  };

  componentWillMount() {
    this.loadCareers();
  }

  componentDidMount() {
    this.loadCareers();
  }

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  scrollToTop = () =>
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);

  loadCareers = (e, filterTeam) => {
    // Event may be passed in from search form
    if (e) e.preventDefault();

    const { team, page, limit, query } = this.state;

    this.startLoad();

    const queryTeam = filterTeam || team;
    const where = JSON.stringify({
      ...(queryTeam !== '' && { team: queryTeam }),
      ...(query !== '' && {
        title: { $like: `%${query}%` },
        // excerpt: { $like: `%${query}%` },
        // description: { $like: `%${query}%` },
      }),
    });

    callApi('/careers', {
      ...(!!where && { where }),
      ...(!!page ? { page } : 1),
      ...(!!limit ? { limit } : 20),
    })
      .then(({ data = [], meta = {} }) => {
        this.setState({ careers: data, loading: false, meta });
        this.scrollToTop();
      })
      .catch((err) => {
        this.stopLoad();
        this.props.dispatch(showError(err.message));
      });
  };

  setPage = (page) => {
    if (page) {
      this.setState({ page }, () => {
        this.loadCareers();
      });
    }
  };

  setQuery = (e) => {
    this.setState({ query: e.target.value });
  };

  filterByTeam = (e) => {
    this.loadCareers(null, e.target.value !== 'all' ? e.target.value : '');
  };

  openCareer = (campaign) => {
    // this.props.dispatch(openCareerModal(id));
    this.props.history.push(`/careers/${campaign.id}`);
    // this.props.dispatch(setCustomerDetails(campaign));
  };

  refresh = () => {
    window.location.reload();
  };

  render() {
    const { query, careers, page, loading, limit } = this.state;

    const hasResults = careers.length > 0;
    return (
      <div className="container-fluid">
        <CreateCareerModal refresh={this.refresh} />
        <Row className="mt-3 mt-md-4">
          <Col xs={12}>
            <PageHeader
              title="CAREERS"
              subtitle={<>All Careers - Page {page}</>}
            >
              <Button
                // size="sm"
                // disabled={}
                color={'primary'}
                onClick={() => {
                  this.props.dispatch(openCreateCareerModal());
                }}
              >
                Create Job Listing
              </Button>
              <SearchForm
                value={query}
                onChange={this.setQuery}
                onSearch={this.loadCareers}
                loading={loading}
              />
              <FormGroup>
                <Input
                  id="status"
                  name="status"
                  type="select"
                  onChange={this.filterByTeam}
                >
                  <option value={'all'}>Filter By Team</option>
                  {this.state.teams.map((type, index) => (
                    <option key={index} value={type.toLocaleLowerCase()}>
                      {type.toUpperCase()}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </PageHeader>

            <DataTable
              minWidth={800}
              loading={loading}
              page={page}
              onPageChange={this.setPage}
              showPagination={hasResults}
            >
              <thead className="text-primary">
                <tr>
                  <th>No.</th>
                  <th>Title</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>CreatedAt</th>
                </tr>
              </thead>

              <tbody>
                {careers.map((u, i) => (
                  <tr onClick={() => this.openCareer(u)} key={u.id}>
                    <td>{loading ? '—' : i + 1 + (page - 1) * limit}</td>
                    <td>{u.title}</td>
                    <td>{u.team}</td>
                    <td>{u.status}</td>
                    <td>{formatDate(u.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </DataTable>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(Careers);
